import { cn } from 'src/shadcn/lib/utils';
import * as React from 'react';

export interface IScrollablePageProps extends React.PropsWithChildren {
  className?: string;
  contentClassName?: string;
  id?: string;
}

export const ScrollablePage: React.FunctionComponent<
  IScrollablePageProps
> = props => {
  return (
    <div className={cn('flex flex-1 overflow-hidden', props.className)}>
      <div
        className={cn(props.contentClassName, 'h-full w-full overflow-auto')}
        id={props.id}
      >
        {props.children}
      </div>
    </div>
  );
};
